import { getAccessTokenAsync } from './auth/auth';

const base = process.env.REACT_APP_API_URL;
var cache;
caches?.open('API').then(c => cache = c);

export const Api = {
    async delete(path, data, signal) {
        let res = await fetch(pathJoin(base, path), {
            method: 'DELETE',
            headers: {
                'Authorization': 'Bearer ' + await getAccessTokenAsync(),
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data),
            signal
        });

        if (!res.ok) {
            const errorData = await res.json();

            if ('message' in errorData)
                throw new Error(errorData.message);

            throw new Error(`HTTP error! Status: ${res.status}, Message: ${JSON.stringify(errorData)}`);
        }

        return res.json();
    },

    async patch(path, data, signal) {
        let res = await fetch(pathJoin(base, path), {
            method: 'PATCH',
            headers: {
                'Authorization': 'Bearer ' + await getAccessTokenAsync(),
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data),
            signal
        });

        if (!res.ok) {
            const errorData = await res.json();

            if ('message' in errorData)
                throw new Error(errorData.message);

            throw new Error(`HTTP error! Status: ${res.status}, Message: ${JSON.stringify(errorData)}`);
        }

        return res.json();
    },

    async post(path, data, signal) {
        let res = await fetch(pathJoin(base, path), {
            method: 'POST',
            headers: {
                'Authorization': 'Bearer ' + await getAccessTokenAsync(),
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data),
            signal
        });

        if (!res.ok) {
            const errorData = await res.json();

            if ('message' in errorData)
                throw new Error(errorData.message);

            throw new Error(`HTTP error! Status: ${res.status}, Message: ${JSON.stringify(errorData)}`);
        }

        return res.json();
    },

    async get(path, data, signal) {
        let res = await fetch(getUrl(path, data), {
            method: 'GET',
            headers: {
                'Authorization': 'Bearer ' + await getAccessTokenAsync()
            },
            signal
        });

        if (!res.ok) {
            const errorData = await res.json();

            if ('message' in errorData)
                throw new Error(errorData.message);

            throw new Error(`HTTP error! Status: ${res.status}, Message: ${JSON.stringify(errorData)}`);
        }

        return res.json();
    },

    async cache(path, data) {
        if (!cache) return await Api.get(path, data);

        let url = getUrl(path, data);

        let match = await cache.match(url);
        
        if (match) return match.json();

        let res = await fetch(url, {
            method: 'GET',
            headers: {
                'Authorization': 'Bearer ' + await getAccessTokenAsync()
            }
        });
        
        cache.put(url, res);

        return res.json();
    }
};

const getUrl = (path, data) =>  {
    let url = new URL(pathJoin(base, path));

    for (var param in data) {
        url.searchParams.append(param, data[param]);
    }

    return url.href;
}

export const pathJoin = (...args) =>
    (args.length === 1) ? args?.[0]
    : pathJoin(...[(args?.[0]?.toString().endsWith('/') ? args[0].slice(0, -1) : args[0]) + '/' + (args?.[1]?.toString().startsWith('/') ? args[1].slice(1) : args[1]), ...args.splice(2)]);